// extracted by mini-css-extract-plugin
export default {"container":"filedrop_container__fAj4m","msg":"filedrop_msg__DJVED","caveat":"filedrop_caveat__fQzna"};